import React from 'react'
import { Button, Form, Table, Icon, Element } from 'react-bulma-components'
import { faExclamationTriangle, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CloudinaryImage from '../cloudinary/image'
import { Link, useTranslation } from 'gatsby-plugin-react-i18next'
import SearchComponent from '../form/search-component'
import { useSession } from '../../stores/session'
import ProductStock from '../products/stock'


const Basket = ({ basket, addItemToBasket, removeItemFromBasket, priceRequest, light }) => {
  const [sessionState] = useSession()

  const { t } = useTranslation()
  const total = React.useMemo(() => {
    let count = 0
    basket.forEach(basketItem => {
      if (!sessionState.currentUser)
        count += basketItem.product.pricing.srp * basketItem.quantity
      else if (basketItem.product && basketItem.pricing && basketItem.pricing.PHTAX)
        count += basketItem.pricing.PHTAX * basketItem.quantity
    })
    return count.toFixed(2)
  }, [basket])

  return (
    <Element>
      <Element style={{ maxWidth: 400, }} mb={3}>
        <Element mb={1}>{t('basket:add_product')}:</Element>
        <SearchComponent
          width='400px'
          onChange={(value) => !basket.some(i => i.item === value.value) && addItemToBasket({
            item: value.value,
            quantity: 1
          }) }
          onlyProduct
        />
      </Element>
      <Table.Container mb={1}>
        <Table hoverable size='fullwidth'>
          <thead>
            <Element textWeight='bold' renderAs='tr'>
              <Element renderAs='td'>
                {t('basket:product')}
              </Element>
              <Element renderAs='td'>{t('basket:description')}</Element>
              <Element renderAs='td'>{t('basket:stock')}</Element>
              {
                !light &&
                  <Element renderAs='td' textAlign='right'>{t('basket:price')}</Element>
              }
              { sessionState.currentUser && <Element renderAs='td' textAlign='right'>{t('basket:price')} %</Element> }
              <Element renderAs='td'>{t('basket:quantity')}</Element>
              {/*
                !light &&
                  <Element renderAs='td'>
                    <Tag
                      size='medium'
                      color='white'
                    >
                      <Icon
                        color='warning'
                      >
                        <FontAwesomeIcon
                          icon={faExclamationCircle}
                        />
                      </Icon>
                    </Tag>
                  </Element>
              */}
              <Element renderAs='td' textAlign='right'>{t('basket:total')}</Element>
              {
                !light &&
                  <Element renderAs='td'></Element>
              }
            </Element>
          </thead>
          <tbody>
            {
              basket.map((basketItem) =>
                basketItem.product &&
                  <tr key={ basketItem.product._id }>
                    <Element renderAs='td'>

                      <CloudinaryImage
                        publicId={basketItem.product.pictures[0] && basketItem.product.pictures[0].item.providerId}
                        transformations={{
                          width: '60',
                          height: '60',
                          crop: 'thumb',
                        }}
                      />
                    </Element>
                    <Element renderAs='td'>
                      <Link to={`/products/${basketItem.product._id}/`}>
                        { basketItem.product.name.fr }
                      </Link>
                    </Element>
                    <Element renderAs='td'>
                      { (basketItem.product.stock.available === 0 || basketItem.product.stock.available < basketItem.quantity) && !sessionState.currentUser &&
                        <Element renderAs='span' mr={1} textColor='danger'><FontAwesomeIcon icon={faExclamationTriangle} /></Element>
                      }
                      <ProductStock currentUser={sessionState.currentUser} stock={basketItem.product.stock.available}/>
                    </Element>
                    {
                      !light &&
                        <Element renderAs='td' textAlign='right'>
                          { (sessionState.currentUser ? basketItem.product.pricing.price : basketItem.product.pricing.srp).toFixed(2) }&nbsp;€
                        </Element>
                    }
                    {
                      sessionState.currentUser &&
                        <Element renderAs='td' textAlign='right'>
                          {
                            priceRequest && priceRequest.status === 'inProgress' ?
                              <FontAwesomeIcon icon={faSpinner} spin/> :
                              <span>{basketItem.pricing && basketItem.pricing.PHTAX}&nbsp;€</span>
                          }
                        </Element>
                    }
                    <Element renderAs='td'>
                      {
                        light ?
                          <span>{basketItem.quantity}</span>
                          :
                          <Form.Input
                            size='small'
                            type='number'
                            min={1}
                            value={basketItem.quantity}
                            style={{ width: '4.5rem' }}
                            onChange={ (e) => addItemToBasket({
                              item: basketItem.item,
                              quantity: Number(e.target.value) || 1
                            }) }
                          />
                      }
                    </Element>
                    {/*
                      !light &&
                        <Element renderAs='td'>
                          <Tag.Group
                            hasAddons
                            data-tooltip='Commandez 32 produits pour obtenir une remise'
                          >
                            <Tag size='medium' color='white'>
                              <Icon
                                color='warning'
                              >
                                <FontAwesomeIcon
                                  icon={faExclamationCircle}
                                />
                              </Icon>
                            </Tag>
                            <Tag
                              color='warning'
                              size='medium'
                            >
                              32
                            </Tag>
                          </Tag.Group>
                        </Element>
                    */}
                    <Element renderAs='td' textAlign='right'>
                      {
                        priceRequest && priceRequest.status === 'inProgress' ?
                          <FontAwesomeIcon icon={faSpinner} spin/> :
                          <span>
                            { sessionState.currentUser && basketItem.pricing && (basketItem.pricing.PHTAX * basketItem.quantity).toFixed(2) }&nbsp;€

                            { !sessionState.currentUser && ((basketItem.product.pricing.srp).toFixed(2) * basketItem.quantity).toFixed(2)}
                          </span>
                      }
                    </Element>
                    {
                      !light &&
                        <Element renderAs='td'>
                          <Icon>
                            <Button
                              color='grey'
                              size='small'
                              onClick={ () => removeItemFromBasket({ item: basketItem.item }) }
                            >
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                              />

                            </Button>
                          </Icon>
                        </Element>
                    }
                  </tr>
              )
            }
          </tbody>
        </Table>
      </Table.Container>
      {/*
        !light &&
          <Message
            pull='left'
            color='warning'
          >
            <Message.Body>
              <Icon
                color='warning'
                style={{ position: 'relative', top: 1 }}
                mr={4}
              >
                <FontAwesomeIcon icon={faExclamationCircle} />
              </Icon>
              Attention, des remises sont disponibles pour certains volumes de commande
            </Message.Body>
          </Message>
      */}
      <Element textAlign='right' pr={3}>
        <Element renderAs='span' textWeight='bold'>{t('basket:total')} </Element>
        {
          priceRequest && priceRequest.status === 'inProgress' ?
            <FontAwesomeIcon icon={faSpinner} spin/> :
            <span>
              { total }&nbsp;€
            </span>
        }
      </Element>
    </Element>
  )
}

export default Basket